import { StatusBadge } from '@pages/User/components';
import type { RootResourceStatus } from '@root/@types/types';
import { SUBMISSION_STATUSES } from '@root/@types/types';
import { getFormattedStatus } from '@root/helpers/resources';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';

const getAvailableStatuses = (hasFirmOrderStatus: boolean) => {
  if (!hasFirmOrderStatus) {
    return SUBMISSION_STATUSES.filter((status) => status !== 'FIRM_ORDER');
  }

  return SUBMISSION_STATUSES;
};

export const statusAccessor = <T extends { status?: string }>(
  columnHelper: ColumnHelper<T>,
  hasFirmOrderStatus: boolean = false,
) =>
  columnHelper.accessor((entity) => entity.status, {
    id: 'status',
    header: 'Status',
    filterFn: 'arrIncludesSome',
    cell: (cellContext: CellContext<T, RootResourceStatus>) => <StatusBadge status={cellContext.getValue()} />,
    meta: {
      filter: {
        placeholder: 'All statuses',
        selected: getAvailableStatuses(hasFirmOrderStatus).filter((status) => status !== 'ARCHIVED'),
        options: getAvailableStatuses(hasFirmOrderStatus).map((status) => ({
          name: getFormattedStatus(status),
          value: status,
        })),
      },
      dataCellClassName: 'px-3 py-1',
    },
  });
